import { useDisclosure } from '@mantine/hooks'
import { Image, Stack, Text, AspectRatio, Popover } from '@mantine/core'

const HoverCard = ({ title, description, media }) => {
    const [opened, { close, open }] = useDisclosure(false)
    return (
        <Popover
            arrowSize={16}
            opened={opened}
            position='bottom'
            shadow='md'
            width='25%'
            withArrow
        >
            <Popover.Target>
                <Stack onMouseEnter={open} onMouseLeave={close}>
                    <AspectRatio
                        ratio={1}
                        style={{
                            cursor: 'pointer',
                        }}
                        w='100%'
                    >
                        <Image src={media.coverImage.src} />
                    </AspectRatio>
                    <Text component='div' ta='center' fw='bold'>
                        {title}
                    </Text>
                </Stack>
            </Popover.Target>
            <Popover.Dropdown
                bg='lightGrey.0'
                sx={{
                    pointerEvents: 'none',
                }}
            >
                <Text size='md' ta='center'>
                    {description}
                </Text>
            </Popover.Dropdown>
        </Popover>
    )
}
export default HoverCard
